import { useTranslate } from '@growtherapy/i18n';
import { Button, Icon, cn } from '@growtherapy/sprout-ui';

import { ActionType } from './types';
import { MUSIC_ACTION_ICONS } from './useBackgroundMusicPlayback';

export function MusicStateToggleButton({
  className,
  currentActionState,
  isToneLoading,
  onClick,
}: {
  className?: string;
  currentActionState: ActionType;
  isToneLoading: boolean;
  onClick: () => void;
}): JSX.Element {
  const t = useTranslate();
  const nextActionIcon = MUSIC_ACTION_ICONS[currentActionState];

  const label =
    currentActionState === ActionType.PLAY
      ? t('telehealth-core:waitingRoom.musicOn')
      : t('telehealth-core:waitingRoom.musicOff');

  return (
    <Button
      use='link'
      size='sm'
      loading={isToneLoading}
      className={cn(
        'flex gap-x-2 items-center text-yellow-700 no-underline hover:brightness-75 hover:text-yellow-700',
        'rebrand:text-action-primary-textLinkInverse rebrand:hover:text-action-primary-textLinkInverseHover',
        className,
      )}
      onClick={() => onClick()}
      aria-label={label}
    >
      <Icon icon={nextActionIcon} />
      {label}
    </Button>
  );
}
